import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const CalendarCheck: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path
      fillRule={'evenodd'}
      d="M29.499 22.865l.937.902-8.006 8.318-4.874-5.065.937-.902 3.937 4.092 7.069-7.345zM8.87 34.698h30.251v-16.45H8.87v16.45zm3.824-23.91v1.152a2.238 2.238 0 002.235 2.235 2.237 2.237 0 002.234-2.235v-1.152h13.544v1.152a2.238 2.238 0 002.234 2.235 2.237 2.237 0 002.235-2.235v-1.152h3.946v6.16H8.87v-6.16h3.824zm1.301-2.242a.935.935 0 011.868 0v3.394a.935.935 0 01-1.868 0V8.546zm18.013 0a.935.935 0 011.868 0v3.394a.935.935 0 01-1.868 0V8.546zm3.168.941v-.94a2.237 2.237 0 00-2.235-2.236 2.238 2.238 0 00-2.234 2.235v.941H17.163v-.94a2.237 2.237 0 00-2.234-2.236 2.238 2.238 0 00-2.235 2.235v.941H7.57V36h32.852V9.487h-5.246z"
    />
  );

  const normalHover = (
    <path
      fillRule={'evenodd'}
      d="M8.874 34.698h30.251v-16.45H8.874v16.45zm.001-23.91v6.159h30.25v-6.159H35.18v1.152a2.237 2.237 0 01-2.234 2.235 2.238 2.238 0 01-2.235-2.235v-1.152H17.167v1.152a2.237 2.237 0 01-2.234 2.235 2.237 2.237 0 01-2.234-2.235v-1.152H8.875zm5.124 1.152a.934.934 0 001.868 0V8.546a.935.935 0 00-1.868 0v3.394zm18.013 0a.935.935 0 001.868 0V8.546a.935.935 0 00-1.868 0v3.394zm8.414-2.453v26.512H7.574V9.487h5.125v-.941a2.236 2.236 0 012.234-2.234 2.236 2.236 0 012.234 2.234v.941h13.544v-.941a2.237 2.237 0 012.235-2.234 2.236 2.236 0 012.234 2.234v.941h5.246zm-9.633 12.047l.937.903-9.287 9.648-3.478-3.613.937-.903 2.541 2.641 8.35-8.676z"
    />
  );

  const xSmall = (
    <path
      fillRule={'evenodd'}
      d="M29.335 22.703l1.274 1.227-8.174 8.492-5.043-5.24 1.273-1.226 3.77 3.916 6.9-7.169zM9.108 34.463h29.783V18.482H9.108v15.981zm3.357-23.441v.918a2.472 2.472 0 002.47 2.47 2.472 2.472 0 002.467-2.47v-.918h13.075v.918a2.472 2.472 0 002.468 2.47 2.471 2.471 0 002.469-2.47v-.918h3.477v5.692H9.108v-5.692h3.357zm1.768-2.476a.7.7 0 011.4 0v3.394a.7.7 0 11-1.4 0V8.546zm18.014 0a.7.7 0 111.398 0v3.394a.7.7 0 11-1.398 0V8.546zm3.167.707v-.707a2.47 2.47 0 00-2.469-2.468 2.472 2.472 0 00-2.468 2.468v.707H17.402v-.707a2.472 2.472 0 00-2.468-2.468 2.472 2.472 0 00-2.47 2.468v.707H7.34v26.98h33.32V9.253h-5.246z"
    />
  );

  const xSmallHover = (
    <path
      fillRule={'evenodd'}
      d="M9.11 34.464H38.89V18.483H9.11v15.981zm0-23.442v5.69H38.89v-5.69h-3.476v.919a2.472 2.472 0 01-2.47 2.468 2.472 2.472 0 01-2.468-2.468v-.919H17.401v.919a2.472 2.472 0 01-2.468 2.468 2.472 2.472 0 01-2.468-2.468v-.919H9.11zm5.123.919a.7.7 0 101.4 0V8.547a.7.7 0 10-1.4 0v3.394zm18.013 0a.7.7 0 101.4 0V8.547a.7.7 0 00-1.4 0v3.394zm8.414-2.688v26.98H7.34V9.254h5.125v-.706a2.47 2.47 0 012.468-2.469 2.47 2.47 0 012.468 2.469v.706h13.076v-.706a2.47 2.47 0 012.469-2.469 2.471 2.471 0 012.47 2.469v.706h5.244zM30.625 21.37l1.274 1.227-9.456 9.825-3.646-3.79 1.275-1.226 2.37 2.464 8.183-8.5z"
    />
  );

  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};

export default CalendarCheck;
